'use client';

import type { LeadInput } from '@jlg-website/shared';

export function QuestionsFilledOut(input: LeadInput) {
  window.JLG?.analytics?.queue?.push({
    data: {
      form: {
        contact_filled_out: false,
        form_filled_out: false,
        internal_event: 'QuestionsFilledOut',
        questions_filled_out: true,
        steps: {
          count: 1,
          current: 1,
        },
        two_fa_completed: true,
      },
      session: {
        campaign: {
          id: window?.JLG?.marketing?.campaign?.id || '',
          lead_score_baseline: window.JLG?.marketing?.lead_score_baseline ?? 0,
          lead_source: {
            id: window?.JLG?.marketing?.lead_source?.id || '',
          },
          lead_type: {
            id: window?.JLG?.marketing?.lead_type?.id || '',
            lead_type_name: window.JLG?.marketing?.lead_type?.name ?? 'Personal Injury',
          },
        },
        form: {
          id: 1,
        },
        lead: {
          answers: input.lead.answers,
          contact: input.lead.contact,
          id: null,
          is_duplicate: null,
          is_qualified: input.lead.is_qualified,
          score: input.lead.score,
        },
        session: window.JLG?.analytics?.session?.session_id,
      },
    },
    name: 'FormEvent',
  });
}

export function ContactFilledOut(input: LeadInput) {
  window.JLG?.analytics?.queue?.push({
    data: {
      form: {
        contact_filled_out: true,
        form_filled_out: true,
        internal_event: 'ContactFilledOut',
        questions_filled_out: true,
        steps: {
          count: 1,
          current: 1,
        },
        two_fa_completed: true,
      },
      session: {
        campaign: {
          id: window?.JLG?.marketing?.campaign?.id || '',
          lead_score_baseline: window.JLG?.marketing?.lead_score_baseline ?? 0,
          lead_source: {
            id: window?.JLG?.marketing?.lead_source?.id || '',
          },
          lead_type: {
            id: window?.JLG?.marketing?.lead_type?.id || '',
            lead_type_name: window.JLG?.marketing?.lead_type?.name ?? 'Personal Injury',
          },
        },
        form: {
          id: 1,
        },
        lead: {
          answers: input.lead.answers,
          contact: input.lead.contact,
          id: null,
          is_duplicate: input.lead.is_qualified,
          is_qualified: true,
          score: input.lead.score,
        },
        session: window.JLG?.analytics?.session?.session_id,
      },
    },
    name: 'FormEvent',
  });
}

export function LeadCreated(leadId: number, input: LeadInput) {
  window.JLG?.analytics?.queue?.push({
    data: {
      form: {
        internal_event: 'LeadCreated',
        steps: {},
      },
      session: {
        campaign: {
          id: window?.JLG?.marketing?.campaign?.id || '',
          lead_score_baseline: window.JLG?.marketing?.lead_score_baseline ?? 0,
          lead_source: {
            id: window?.JLG?.marketing?.lead_source?.id || '',
          },
          lead_type: {
            id: window?.JLG?.marketing?.lead_type?.id || '',
            lead_type_name: window.JLG?.marketing?.lead_type?.name ?? 'Personal Injury',
          },
        },
        form: {
          id: 1,
        },
        lead: {
          answers: input.lead.answers,
          contact: input.lead.contact,
          id: leadId,
          is_duplicate: false,
          is_qualified: input.lead.is_qualified,
          score: input.lead.score,
        },
        session: window.JLG?.analytics?.session?.session_id,
      },
    },
    name: 'FormEvent',
  });
}
